var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('currency-field',{attrs:{"field":_vm.field,"value":_vm.value,"name":_vm.name,"has-error":_vm.hasError},on:{"input":_vm.updateValueData}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.valueData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }